export interface ApiConfig {
  url: string

}

const get_profile = () => {
  const host = window.location.host;
  if (host === 'localhost:3000') return 'dev';
  if (host === 'ielts-staging.web.app') return 'staging';
  // Remaining host need to be added here going forth as per env setup
  return 'unknown';
};

let DOMAIN = 'https://ielts1.api.cambri.ai';
let OAuth ='https://ielts1.api.cambri.ai/api/auth/google'
let cloudServiceUrl = "https://ictsystems.cambri.ai";
let applicationUrl = "ielts.web.cambri.ai";
let project = 106;
const profile = get_profile();


switch (profile) {
  case 'dev':
    case 'staging':
    DOMAIN = 'https://staging.api.ielts.cambri.ai';
    OAuth ='https://staging.api.ielts.cambri.ai/api/auth/google'
    cloudServiceUrl = "https://ictservice.cambri.ai"
    applicationUrl = "ielts-staging.web.app"
    break;
  default:
    break;
}

export const be_url = DOMAIN;

export const cloudService = cloudServiceUrl;
export const cloudApplicationUrl = applicationUrl;
export const projectCode = project;

export const commonHeaders = {
  'Content-Type': 'application/json',
};
export const DEFAULT_API_CONFIG: ApiConfig = {
  url: `${DOMAIN}/api`,

}

export const OAuthUrl =OAuth
